/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

export class MagApi {
    constructor(api) {
        this.api = api;
    }

    async getArticles() {
        const result = await this.api.get(`/articles`, { sort: "order,asc" });
        return result._embedded.linkedContents;
    }
    
    async getPublicArticles() {
        const result = await this.api.get(`/public/articles`, { sort: "order,asc" });
        return result._embedded.linkedContents;
    }

    async getCategories() {
        const result = await this.api.get(`/article-categories`, { sort: "order,asc" });
        const categories = result._embedded.articleCategories;
        return categories;
    }

    async getArticleBySlugOrContentId(slugOrContentId) {
        return await this.api.get(`/articles/findBySlugOrContentId/${slugOrContentId}`);
    }
}
